/**
 * ═══════════════════════════════════════════════════════════════════════════
 * GENERADO. NO SE EDITA A MANO.
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Sale de `scripts/generar-cifras.ts`, que cuenta el catálogo servido y las
 * preguntas de la puerta.
 *
 * Se escribe en vez de importarse para no meter el catálogo entero en el
 * bundle de quien solo quiere el número. La landing y la portada de la
 * plataforma dicen la misma cifra, y ninguna de las dos necesita las fichas
 * para decirla.
 *
 * `npm run verificar:cifras` comprueba en cada build que estos números siguen
 * siendo los de verdad, así que desincronizarlos rompe el build y no la
 * promesa.
 *
 *     npm run cifras
 */

/** Fichas de gesto escritas enteras y servidas hoy. */
export const FICHAS = 255;

/** Las que no le piden nada a la voz. Sostiene el «se puede hacer hoy». */
export const SIN_CARGA = 79;

/** Las que se pueden hacer sin que nadie te oiga. */
export const SILENCIOSAS = 76;

/** Las que llevan una fuente publicada detrás, y no criterio propio. */
export const CON_FUENTE = 134;

/**
 * Cuántas preguntas de seguridad hay que contestar antes de ver el plan.
 *
 * Es una promesa de esfuerzo, de las que más pesan al decidir si empezar.
 */
export const PREGUNTAS = 13;

/**
 * Cuántas fichas recibe una persona real en su plan.
 *
 * Sale de `@vc/dominio`, de al lado de las tallas que la producen. Aquí se
 * copia el valor para no meterle el motor al bundle de la landing, y
 * `verificar:cifras` comprueba que sigue siendo el mismo.
 */
export const EN_TU_PLAN = { min: 8, max: 15 } as const;
